<template>
    <Breadcrumbs main="Bonus Ui" title="Sweet Alert" />
    <div class="container-fluid">
        <div class="row">
            <basicAlert />
            <textUnder />
            <infoAlert />
            <warningAlert />
            <pikachuAlert />
            <questionsAlert />
            <usernameAlert />
            <successMessage />
            <dangerAlert />
            <warningMode />
            <autoClose />
            <requestMovie />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/basicAlert.vue"))
const textUnder = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/textUnder.vue"))
const infoAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/infoAlert.vue"))
const warningAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/warningAlert.vue"))
const pikachuAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/pikachuAlert.vue"))
const questionsAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/questionsAlert.vue"))
const usernameAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/usernameAlert.vue"))
const successMessage = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/successMessage.vue"))
const dangerAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/dangerAlert.vue"))
const warningMode = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/warningMode.vue"))
const autoClose = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/autoClose.vue"))
const requestMovie = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/requestMovie.vue"))
</script>